// extracted by mini-css-extract-plugin
module.exports = {"layout":"layout--Q0DK2"};